import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { APP_ENVIRONMENT } from '@core/config/app-environment';
import { Observable } from 'rxjs';
import { SessionAccount } from './models/session.models';

/**
 * cc-rt-core session client. Role, permissions and organizations come from the server (cc-auth-svc), never from
 * the browser storage.
 */
@Injectable({ providedIn: 'root' })
export class SessionApi {
  private readonly http = inject(HttpClient);
  private readonly env = inject(APP_ENVIRONMENT);

  /** `GET /api/v1/session/me`: 401 without session, 403 without access to RT. */
  me(): Observable<SessionAccount> {
    return this.http.get<SessionAccount>(`${this.env.API_RT_CORE}/api/v1/session/me`);
  }

  /** `DELETE /api/v1/session/me/cache`: removes the cached cc-auth account of the session (logout). Always 204. */
  evictCache(): Observable<void> {
    return this.http.delete<void>(`${this.env.API_RT_CORE}/api/v1/session/me/cache`);
  }
}
